import {ResolveFn} from '@angular/router';
import {inject} from '@angular/core';
import {map} from 'rxjs/operators';
import {RateCategoryService} from '../../../apiModule/api/rate-category.service';
import {RateCategory} from '../../../apiModule/model/rate-category';

export const rateCategoryResolver: ResolveFn<any> = (
  _,
  __,
  rateCategoryService: RateCategoryService = inject(RateCategoryService)
) => {
  return rateCategoryService
    .apiRemarktypeGet({}, 'body', false, {transferCache: false})
    .pipe(map(res => ({
      pager: res.pager,
      values: res.values.map((item: {
        id: number,
        name: string,
        shortName: string,
        coefficient: number,
        status: StatusRemarkType
      }) => new RateCategory(item.id, item.name, item.shortName, item.coefficient, item.status))
    })));
};